import Model from '@/store/plugins/orm/Model'
import { Order, CashRegister, UserTransaction, AppEvent } from './ModelRepository'

import ApiService from '@/services/ApiService'
import i18n from '@/i18n';
import HashGen from '@/utilities/HashGen';

export class Shift extends Model {
    static get entity() {
        return 'shifts';
    }

    static get primaryKey() {
        return 'hash';
    }

    static get DATE_FORMAT() {
        return 'YYYY-MM-DDTHH:mm:ssZ';
    }

    static fields() {
        return {
            id: this.attr(null),
            hash: this.attr(HashGen.regular()),
            opened_at: this.attr(null),
            closed_at: this.attr(null),
            cash_register_id: this.attr(null),

            cash_register: this.belongsTo(CashRegister, 'cash_register_id'),

            sync_needed: this.attr(null)
        };
    }

    /**
     * Get the currently opened Shift
     */
    static current() {
        const curCashRegister = CashRegister.current();
        if(!curCashRegister) return null;

        return Shift.all().find(shift => !shift.closed_at && shift.cash_register_id === curCashRegister.id)
    }

    getOpenedAt() {
        return moment.utc(this.opened_at).local();
    }

    getOrders() {
        return Order.all().filter(order => {
            return (this.id && this.id === order.shift_id) || (this.hash && this.hash === order.shift_hash)
        })
    }

    getUserTransactions() {
        return UserTransaction.all().filter(transaction => {
            return (this.id && this.id === transaction.shift_id) || (this.hash && this.hash === transaction.shift_hash)
        })
    }

    /**
     * Open Shift
     */
    static async open() {
        try {
            const curCashRegister = CashRegister.current();

            if(!curCashRegister) {
                return {
                    success: false,
                    error: i18n.t('cash_register.registration_needed_short')
                };
            }

            if(!Shift.store().getters.isOnline) {
                const shift = new Shift({
                    opened_at: moment().utc().format(Shift.DATE_FORMAT),
                    cash_register_id: curCashRegister.id,
                    sync_needed: this.store().getters.tenant.venue.hash
                });

                shift.$save();
                return { success: true };
            }

            // Open shift on server
            const response = await ApiService.post('/shift/open', {})

            Shift.create({ data: [response.data.shift] });

            AppEvent.build('shiftUpdate').send()

            return { success: true };
        } catch(error) {
            return {
                success: false,
                error: i18n.t('general.action_failed')
            };
        }
    }

    /**
     * Close Shift
     */
    static async close() {
        const curCashRegister = CashRegister.current();

        try {
            if(!curCashRegister) {
                return {
                    success: false,
                    error: i18n.t('cash_register.registration_needed_short')
                };
            }

            if(!Shift.store().getters.isOnline) {
                const shift = Shift.current();

                if(!shift) {
                    return {
                        success: false,
                        error: i18n.t('general.action_failed')
                    };
                }

                shift.closed_at = moment().utc().format(Shift.DATE_FORMAT)
                shift.sync_needed = this.store().getters.tenant.venue.hash
                shift.$save()

                return { success: true };
            }

            await ApiService.post('/shift/close', {})
            Shift.deleteAll()

            AppEvent.build('shiftUpdate').send()

            return { success: true };
        } catch(error) {
            return {
                success: false,
                error: i18n.t('general.action_failed')
            };
        }
    }

}

export default Shift
